(function() {
  'use strict';
  
  angular
    .module('app.shell')
    .directive('marsRememberScrollPosition', marsRememberScrollPosition);
  
  marsRememberScrollPosition.$inject = [
    '$log', 
    '$anchorScroll', 
    '$timeout',
    '$transitions'
  ];
  
  function marsRememberScrollPosition(
    $log, 
    $anchorScroll, 
    $timeout, 
    $transitions
  ) {
    $log = $log.getInstance('marsRememberScrollPosition');
    
    var directive = {
      link: link,
      restrict: 'E',
      scope: {
        view: '@'
      }
    }

    var scrollPositions = {};

    return directive;
    
    function link(scope, ele, attrs) {
      var mdContent = ele.parent()
      // Walk up the DOM to find closest md-content parent
      while (mdContent.length > 0) {
        if (mdContent[0].tagName === 'MD-CONTENT') break;
        else mdContent = mdContent.parent()
      }

      if (mdContent[0].tagName !== 'MD-CONTENT')
        return $log.error('marsRememberScrollPosition directive must be used within an md-content element')
      
      var removeStartHook = $transitions.onStart({}, function() {
        scrollPositions[scope.view] = mdContent[0].scrollTop;
      });
      scope.$on('$destroy', removeStartHook);
      
      attrs.$set('id', 'previous-scroll-position');
      $timeout(function(){
        ele.css({ position: 'absolute', top: (scrollPositions[scope.view] || 0) + 'px' });
        $anchorScroll('previous-scroll-position'); 
      }, 0)
    }

  }
  
})();